import { Stack } from "@mantine/core";
import ManualImport from "../../lists/import/manualImport/ManualImport";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "../../../../stores/LanguageStore";

const UnsubsImportPage = () => {
  const lang = useLanguage((s) => s.language);
  const navigate = useNavigate();

  return (
    <Stack mt={24} flex={1} w={"80%"} mx={"auto"}>
      <ManualImport
        onFinish={(id) => navigate("/unsubscribers/" + id)}
        setActiveWindow={() => navigate("..")}
        isUnsub
        isActive={"manual"}
      />
    </Stack>
  );
};

export default UnsubsImportPage;
